export const CREATE_PURCHASE_CHALLAN = 'CREATE_PURCHASE_CHALLAN';
export const GET_PURCHASE_CHALLANS = 'GET_PURCHASE_CHALLANS';
export const PURCHASE_CHALLAN_REQUEST = 'PURCHASE_CHALLAN_REQUEST';
export const UPDATE_PURCHASE_CHALLAN = 'UPDATE_PURCHASE_CHALLAN';
export const DELETE_PURCHASE_CHALLAN = 'DELETE_PURCHASE_CHALLAN';
export const PURCHASE_CHALLAN_REQUEST_FAILURE = 'PURCHASE_CHALLAN_REQUEST_FAILURE';
export const GET_PURCHASE_CHALLANS_PAGE = 'GET_PURCHASE_CHALLANS_PAGE';
export const PURCHASE_CHALLAN_REQUEST_SUCCESS = 'PURCHASE_CHALLAN_REQUEST_SUCCESS';